module.exports = __webpack_public_path__ + "img/qg2_11.5999dd91.png";